module.exports = __webpack_public_path__ + "b32bb980396f0f98c8f421e053e45ca2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/exclusiveOffer.svg
// module id = 180
// module chunks = 0